import { render, staticRenderFns } from "./DxEffortActivity.vue?vue&type=template&id=35b12076&"
import script from "./DxEffortActivity.vue?vue&type=script&lang=js&"
export * from "./DxEffortActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports